export enum RunState {
    Pending = 'pending',
    Idle = 'idle',
    Enqueued = 'enqueued',
    Running = 'running',
    Failed = 'failed',
    Complete = 'complete',
    Cancelled = 'cancelled',
    ResultAvailable = 'result-available',
}
